module.exports = __webpack_public_path__ + "img/ic_country_serve_img2.59872d5e.png";